import React, { useState, useEffect } from 'react';
import Chart from "react-google-charts";
import { connect } from 'react-redux';
import moment from 'moment';
import { Form } from 'react-bootstrap';
import { pesquisaqtde as pesquisaqtdecredencial } from '../../../../actions/credenciamento/credencial';

const StatusCredenciamento = (props) => {

    const [qtdepesquisa, setQtdePesquisa] = useState({});
    
    const handlePesquisaCreds = async () => {
        const creds = await props.pesquisaqtdecredencial({
            idevento: props.idevento,
            idpromotora: props.idpromotora,
            filtro_campos: "idparalelo,quantiadede,idfisica"
        });

        let datas_quantidades = {};        
        if(creds&&creds[0]&&creds[0].idevento){            
            creds[0].pedidos.forEach(itens => {
                let qtde = 0;
                itens.inscritoitensescolhidos.forEach(itenspedido => {
                    qtde += itenspedido.quantidade;
                });
                let str = itens.created.split(' ');
                let data = str[0].split('/');
                if(data[2]){
                    const data_campo = `${moment(data[2]+data[1]+data[0]).format("YYYY-MM-DD")}`;
                    datas_quantidades = {
                        ...datas_quantidades,
                        [data_campo]: datas_quantidades[data_campo]?datas_quantidades[data_campo]+qtde:qtde
                    }    
                }
            });
        }
        setQtdePesquisa(datas_quantidades);
    }

    useEffect(() => {
        handlePesquisaCreds();
    },[]);
        
    let total_credencial = 0;
    const datas_caleandario = Object.keys(qtdepesquisa).map(itens => {
        const str = itens.split("-");
        total_credencial += qtdepesquisa[itens];
        return [new Date(str[0],str[1]-1,str[2]), qtdepesquisa[itens]];
    });
    
    const data = [
        [
            {
                type: "date",
                id: "Date"
            },
            {
                type: "number",
                id: "Won/Loss"
            }
        ],
        ...datas_caleandario
    ];
    return null;
    return (
        <Chart 
        chartType="Calendar"        
        options={
            {
                title: `TOTAL Credenciados: ${total_credencial}`,
                height: 165,                
                calendar: {
                    cellSize: 15,
                    daysOfWeek: 'DSTQQSS'                    
                }
        }} 
        data={data} />
    );
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks
    }
}

export default connect(mapStateToProps,{pesquisaqtdecredencial})(StatusCredenciamento);